import React, { useEffect, useMemo, useState } from "react";
import Modal from "../Modal";
import { IoMdClose } from "react-icons/io";
import { FiAlertTriangle } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { HiOutlineChevronDown, HiOutlinePlus } from "react-icons/hi2";
import WorkSpaceRadio from "./WorkSpaceRadio";
import WorkSpaceEntry from "./WorkSpaceEntry";
import { addWorkspaceToUser, fetchUser } from "../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { FaFilter } from "react-icons/fa";

const Workspaces = ({ isOpen, hideModal }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector(state => state.userReducer.user);

    const [showItemModal, setShowItemModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingItem, setEditingItem] = useState({});
    const [selected, setSelected] = useState(user?.current_workspace || null);
    const [error, setError] = useState("");
    const [search, setSearch] = useState("");

    useEffect(() => {
        setSelected(user?.current_workspace || null);
    }, [user?.current_workspace]);

    const attachNewWorkspace = (workspace) => {
        dispatch(addWorkspaceToUser(workspace));
    };

    const refreshUser = () => {
        dispatch(fetchUser());
    };

    const handleWorkspaceChange = (workspaceId) => {
        setSelected(workspaceId);
        history.push(`/switch-workspace`);
    };

    const handleAddWorkspace = () => {
        setEditingItem({});
        setIsEditing(false);
        setShowItemModal(true);
    };

    const handleEditWorkspace = (workspace) => {
        setEditingItem(workspace);
        setIsEditing(true);
        setShowItemModal(true);
    };

    const showError = (message) => {
        setError(message);
        setTimeout(() => {
            setError("");
        }, 3000);
    };

    const filteredWorkspaces = useMemo(() => {
        if (!user?.workspaces) return [];

        const term = search.trim().toLowerCase();
        if (!term) return user.workspaces;

        return user.workspaces.filter((workspace) => {
            const name = workspace?.name?.toLowerCase() || "";
            const title = workspace?.title?.toLowerCase() || "";
            return name.includes(term) || title.includes(term);
        });
    }, [user?.workspaces, search]);

    return (
        isOpen && (
            <Modal>
                <div className="modal d-block workspace-modal-overlay" onClick={hideModal} style={{ zIndex: 100 }}>
                    <div className="workspace-modal new-workspace-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="workspace-modal-header">
                            <h4 className="workspace-modal-heading">Switch Workspace</h4>

                            <button
                                type="button"
                                className="workspace-modal-close"
                                onClick={hideModal}
                                aria-label="Close modal"
                            >
                                <IoMdClose />
                            </button>
                        </div>

                        {error !== "" && (
                            <div className="workspace-modal-error">
                                <span className="workspace-modal-error-icon">
                                    <FiAlertTriangle />
                                </span>
                                <span>{error}</span>
                            </div>
                        )}

                        <div className="workspace-modal-body">
                            <div className="workspace-modal-controls">
                                <div className="workspace-modal-search">
                                    <FiSearch className="workspace-modal-search-icon" />
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                {/* <button type="button" className="workspace-modal-control-btn">
                                    <span className="workspace-modal-control-left">
                                        <FaFilter className="workspace-modal-control-leading-icon workspace-modal-filter-icon" />
                                        <span>All Groups</span>
                                    </span>
                                    <HiOutlineChevronDown className="workspace-modal-control-trailing-icon" />
                                </button> */}

                                <button
                                    type="button"
                                    className="workspace-modal-control-btn workspace-modal-add-btn"
                                    onClick={handleAddWorkspace}
                                >
                                    <span className="workspace-modal-control-left">
                                        <HiOutlinePlus className="workspace-modal-control-leading-icon" />
                                        <span>Add Workspace</span>
                                    </span>
                                </button>
                            </div>

                            <div className="workspace-modal-divider" />

                            <div className="workspace-modal-list">
                                {filteredWorkspaces.map((workspace, index) => {
                                    return (
                                        <WorkSpaceRadio
                                            key={index}
                                            selected={selected}
                                            onChange={handleWorkspaceChange}
                                            onError={showError}
                                            onRemove={refreshUser}
                                            editItem={() => handleEditWorkspace(workspace)}
                                            id={workspace.id}
                                            name={workspace.name}
                                            accepted={workspace.accepted}
                                            title={workspace.title}
                                            isAdmin={workspace.isAdmin}
                                            active={workspace.active}
                                            plan={workspace.plan}
                                        />
                                    );
                                })}
                            </div>
                        </div>

                        <WorkSpaceEntry
                            showModal={showItemModal}
                            closeModal={() => setShowItemModal(false)}
                            onAdd={attachNewWorkspace}
                            onEdit={refreshUser}
                            isEditing={isEditing}
                            item={editingItem}
                        />
                    </div>
                </div>
            </Modal>
        )
    );
};

export default Workspaces;